
import { getMainUrlKey } from './pageTo';
import { getTopWindow } from './window';

const sessionKey = 'NCCSessionStorage';

export function setSession(key, value) {
    let urlkey = getMainUrlKey();
    let sessionData = getTopWindow()[sessionKey] || {};
    if (sessionData[urlkey]) {
        sessionData[urlkey][key] = value;
    } else {
        sessionData[urlkey] = {};
        sessionData[urlkey][key] = value;
    }
}
export function getSession(key) {
    let urlkey = getMainUrlKey();
    let sessionData = getTopWindow()[sessionKey];
    if (sessionData && sessionData[urlkey]) {
        let data = sessionData[urlkey][key];
        if (data) {
            return data;
        }
    }
    return null;
}

export function delSession(key) {
    let urlkey = getMainUrlKey();
    let sessionData = getTopWindow()[sessionKey];
    if (sessionData && sessionData[urlkey]) {
        delete sessionData[urlkey][key];
    }
}